import { render, staticRenderFns } from "./ListPartners.vue?vue&type=template&id=5c918098"
import script from "./ListPartners.vue?vue&type=script&lang=js"
export * from "./ListPartners.vue?vue&type=script&lang=js"
import style0 from "./ListPartners.vue?vue&type=style&index=0&id=5c918098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports